import { FormattedMessage } from "react-intl";
import LabelLang from "component/LabelLang/label-lang.js";
import { DateFormater } from "functions/dateTimeFormat.js";
import { GetStudyPeriod } from "functions/getStudyPeriod.js";

function PublicationMeta({ publication, searchDetails }) {
  return (
    <div className="box-ver">
      <div className="ver-inf">
        <span>
          <FormattedMessage id="publication-type" />
        </span>
        <span>
          <LabelLang
            id="name"
            defaultValue={publication?.publicationType?.name}
            translations={
              publication?.publicationType?.publicationTypeTranslations
            }
          />
        </span>
      </div>
      <div className="ver-inf">
        <span>
          <FormattedMessage id="topic" />
        </span>
        <span>
          <LabelLang
            id="title"
            defaultValue={publication?.subject?.title}
            translations={publication?.subject?.subjectTranslations}
          />
        </span>
      </div>
      <div className="ver-inf">
        <span>
          <FormattedMessage id="periodical" />
        </span>
        <span>
          <LabelLang
            id="name"
            defaultValue={publication?.periodic?.name}
            translations={publication?.periodic?.periodicTranslations}
          />
        </span>
      </div>
      {searchDetails?.studyPeriod && (
        <div className="ver-inf">
          <span>
            <FormattedMessage id="study-period" />
          </span>
          <span>
            {GetStudyPeriod(
              +publication?.yearTypeId,
              +publication?.periodic?.id,
              searchDetails.studyPeriod
            )}
          </span>
        </div>
      )}
      {searchDetails?.releaseDate && (
        <div className="ver-inf">
          <span>
            <FormattedMessage id="issue-date" />
          </span>
          <span>
            {searchDetails.releaseDate ? (
              <DateFormater
                value={searchDetails.releaseDate}
                type={"monthYear"}
              />
            ) : (
              <FormattedMessage id="data-not-found" />
            )}
          </span>
        </div>
      )}
    </div>
  );
}

export default PublicationMeta;
